import { module } from 'modujs';
import { ScrollTrigger, SplitText } from '../gsap'

export default class AnimText extends module {

    static get settings() {
        return {
            CLASSNAME: 'o-anim-text',
            VISIBLE_CLASS: 'is-inview'
        }
    }

    constructor(m) {
        super(m);

        // Define animation type
        this.block = this.getData('block') !== null
        this.words = this.getData('words') !== null
        this.lines = !this.block && !this.words

        // Define if reveal is needed
        this.immediate = this.getData('immediate') !== null
        this.noScrolltrigger = this.getData('no-scrolltrigger') !== null || this.immediate
    }

    init() {

        this.el.classList.add(AnimText.settings.CLASSNAME)

        // Hidden text per default
        this.isActive = true

        // No split as default
        this.splitType = false

        // No split
        if(this.block) {
            this.splitType = false
            this.el.classList.add('-block')
        }

        // Split for words reveal
        else if(this.words) {
            this.splitType = 'words'
            this.el.classList.add('-words')
        }

        // Split for lines reveal
        else if(this.lines) {
            this.splitType = 'lines, words'
            this.el.classList.add('-lines')
        }

        // Split lines
        this.initSplits()

        // Set scroll trigger
        this.setScrollTrigger()

        // Show immediatly
        if(this.immediate) {
            this.el.classList.add(AnimText.settings.VISIBLE_CLASS)
            this.endReveal()
        }

        // Resize event
        window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setScrollTrigger(create=true) {

        if(this.noScrolltrigger || !this.isActive) {
            this.st = false
            return
        }

        if(this.st) {
            this.st.kill(false)
        }

        if(create) {
            this.st = ScrollTrigger.create({
                trigger: this.el,
                start: 'top 80%',
                onEnter: () => {
                    this.el.classList.add(AnimText.settings.VISIBLE_CLASS)
                    this.endReveal()
                },
            });
        }
    }

    initSplits() {

        if(!this.splitType) {
            return
        }

        // Split text
        this.split = new SplitText(this.el, {
            type: this.splitType,
            linesClass: `${AnimText.settings.CLASSNAME}_line`,
            wordsClass: `${AnimText.settings.CLASSNAME}_word`,
        })

        // Lines
        const lineCount = this.split.lines.length
        if(lineCount > 0) {
            this.el.style.setProperty('--anim-text-line-count', lineCount);
            this.split.lines.forEach(($line, i) => {
                $line.style.setProperty('--anim-text-line-index', i)
            })
        }

        // Words
        const wordCount = this.split.words.length
        if(wordCount > 0) {
            this.el.style.setProperty('--anim-text-word-count', wordCount);
            this.split.words.forEach(($word, i) => {
                $word.style.setProperty('--anim-text-word-index', i)
            })
        }

    }

    revertSplits() {
        if(!this.splitType) return

        this.split.revert()
    }

    resize() {

        if(!this.isActive) {
            return
        }

        if(this.splitType) {
            this.revertSplits()
            this.initSplits()
        }

        this.setScrollTrigger()
    }

    endReveal() {
        this.setScrollTrigger(false)
        this.isActive = false

        setTimeout(() => {
            this.revertSplits()
        }, 2000);
    }

    destroy() {
        window.removeEventListener('resizeEnd', this.onResize)

        if(this.isActive) {
            this.setScrollTrigger(false)
        }
    }
}
